import type { L10n } from '../types'

/**
 * Laboratory biomarkers — separate from BIA body composition.
 * New biomarkers are added to `biomarkerDefs` only; the list, detail,
 * visibility and conversion screens adapt without redesign.
 * No reference ranges and no interpretation are stored on purpose.
 */
export interface BiomarkerDef {
  id: string
  name: L10n
  /** Unit values are stored in. */
  canonicalUnit: string
  /** Multiplier from the canonical unit to each supported unit. */
  factors: Record<string, number>
  decimals: Record<string, number>
}

export interface BiomarkerRecord {
  id: string
  biomarkerId: string
  /** Always stored in the canonical unit. */
  value: number
  /** Unit the user originally entered. */
  enteredUnit: string
  /** ISO date (YYYY-MM-DD). */
  date: string
  source?: string
}

export const biomarkerDefs: BiomarkerDef[] = [
  {
    id: 'testosteroneTotal',
    name: { 'pt-BR': 'Testosterona Total', 'en-US': 'Total Testosterone' },
    canonicalUnit: 'ng/dL',
    // 1 ng/dL = 0.0347 nmol/L
    factors: { 'ng/dL': 1, 'nmol/L': 0.0347 },
    decimals: { 'ng/dL': 0, 'nmol/L': 1 },
  },
]

export const seedBiomarkerRecords: BiomarkerRecord[] = [
  {
    id: 'bm-2',
    biomarkerId: 'testosteroneTotal',
    value: 612,
    enteredUnit: 'ng/dL',
    date: '2026-08-14',
    source: 'Laboratório Vitalis',
  },
  {
    id: 'bm-1',
    biomarkerId: 'testosteroneTotal',
    value: 578,
    enteredUnit: 'ng/dL',
    date: '2026-02-10',
  },
]

export function findBiomarker(id: string): BiomarkerDef | undefined {
  return biomarkerDefs.find((def) => def.id === id)
}
